import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Homecp from '@/components/Homecp'
import mHome from '@/components/mHome'
import mLogin from '@/components/mLogin'
import Estabelecimento from '@/components/Estabelecimento'
import Estabelecimentoa from '@/components/Estabelecimento'
import mEstabelecimento from '@/components/mEstabelecimento'
import mEstabelecimentoa from '@/components/mEstabelecimento'
import Index from '@/components/Index'
import registerUser from '@/components/registerUser'
import EditUser from '@/components/EditUser'
import mEditUser from '@/components/mEditUser'
import mRegisterUser from '@/components/mRegisterUser'
import mRegisterEstab from '@/components/mRegisterEstab'
import RegisterEstabFirst from '@/components/RegisterEstabFirst'
import RegisterEstab from '@/components/RegisterEstab'
import RegisterAnuncio from '@/components/RegisterAnuncio'
import Expedicao from '@/components/Expedicao'
import mExpedicao from '@/components/mExpedicao'
import mMinhaPagina from '@/components/mMinhaPagina'
import MinhaPagina from '@/components/MinhaPagina'
import Visao from '@/components/Visao'
import mVisao from '@/components/mVisao'
import mPolitica from '@/components/mPolitica'
import mExpedicaoAdvice from '@/components/mExpedicaoAdvice'
import ExpedicaoAdvice from '@/components/ExpedicaoAdvice'
import Contato from '@/components/Contato'
import mContato from '@/components/mContato'
import links from '@/components/links'
import tabua from '@/components/tabua'
import mTabua from '@/components/mTabua'
import dTabua from '@/components/dTabua'

import go from '@/components/go'
import goEstab from '@/components/goEstab'
import ViaCep from 'vue-viacep'
//import { advMixin } from '../scripts/advMixin'

Vue.use(ViaCep);
Vue.use(Router);
//Vue.mixin(advMixin);

var router = new Router({
  scrollBehavior() {
     return { x: 0, y: 0 };
  },
//  mixins: [advMixin],
  mode: 'history',
  routes: [
     {
        path: '/',
        name: 'Root',
        component: go
     },
    {
      path: '/go',
      name: 'go',
      component: go
    },
    {
      path: '/Home',
      name: 'Home',
      component: Home
    },
    {
      path: '/mHome',
      name: 'mHome',
      component: mHome
    },
      {
          path: '/mLogin',
          name: 'mLogin',
          component: mLogin
      },
     {
        path: '/Estabelecimento',
        name: 'Estabelecimento',
        component: Estabelecimento
     },
     {
        path: '/Estabelecimentoa',
        name: 'Estabelecimentoa',
        component: Estabelecimentoa
     },
     {
        path: '/mEstabelecimento',
        name: 'mEstabelecimento',
        component: mEstabelecimento
     },
      {
          path: '/mEstabelecimentoa',
          name: 'mEstabelecimentoa',
          component: mEstabelecimentoa
      },
      {
          path: '/registerUser',
          name: 'registerUser',
          component: registerUser
      },
      {
          path: '/mRegisterUser',
          name: 'mRegisterUser',
          component: mRegisterUser
      },
      {
          path: '/EditUser',
          name: 'EditUser',
          component: EditUser
      },
      {
          path: '/mEditUser',
          name: 'mEditUser',
          component: mEditUser
      },
      {
          path: '/mMinhaPagina',
          name: 'mMinhaPagina',
          component: mMinhaPagina
      },
      {
          path: '/MinhaPagina',
          name: 'MinhaPagina',
          component: MinhaPagina
      },
      {
          path: '/mRegisterEstab',
          name: 'mRegisterEstab',
          component: mRegisterEstab
      },
      {
          path: '/RegisterEstab',
          name: 'RegisterEstab',
          component: RegisterEstab
      },
      {
          path: '/RegisterEstabFirst',
          name: 'RegisterEstabFirst',
          component: RegisterEstabFirst
      },
      {
          path: '/RegisterAnuncio',
          name: 'RegisterAnuncio',
          component: RegisterAnuncio
      },
      {
          path: '/Expedicao',
          name: 'Expedicao',
          component: Expedicao
      },
      {
          path: '/mExpedicao',
          name: 'mExpedicao',
          component: mExpedicao
      },
      {
          path: '/Visao',
          name: 'Visao',
          component: Visao
      },
      {
          path: '/mVisao',
          name: 'mVisao',
          component: mVisao
      },
      {
          path: '/mExpedicaoAdvice',
          name: 'mExpedicaoAdvice',
          component: mExpedicaoAdvice
      },
      {
          path: '/mPolitica',
          name: 'mPolitica',
          component: mPolitica
      },
      {
          path: '/ExpedicaoAdvice',
          name: 'ExpedicaoAdvice',
          component: ExpedicaoAdvice
      },
      {
          path: '/Contato',
          name: 'Contato',
          component: Contato
      },
      {
          path: '/mContato',
          name: 'mContato',
          component: mContato
      },
      {
          path: '/links',
          name: 'links',
          component: links
      },
      {
          path: '/tabuadasmares',
          name: 'tabua',
          component: tabua
      },
      {
          path: '/mTabua',
          name: 'mTabua',
          component: mTabua
      },
      {
          path: '/dTabua',
          name: 'dTabua',
          component: dTabua
      },
      {
          path: '/goEstab',
          name: 'goEstab',
          component: goEstab
      },
      {
          path: '/:estabSimple',
          name: 'estabSimple',
          component: goEstab
      },
      {
          path: '/s/:estabSimple',
          name: 'sEstabSimple',
          component: goEstab
      },
      {
          path: '/Homecp',
          name: 'Homecp',
          component: Homecp
      }
  ]
});
export default router;

router.beforeEach((to, from, next) => {
    // console.log('beforeEach::popStateDetected:: ', window.popStateDetected);
    console.log('beforeEach::from: ', from);
    console.log('beforeEach::to: ', to);
    console.log('to.params.estabSimple: ', to.params.estabSimple);
    console.log('from.params.estabSimple ', from.params.estabSimple);
    // console.log('beforeEach::next: ', next);
    console.log('beforeEach::to::len   ', (Object.keys(to.params).length) );
    console.log('beforeEach::from::len ', (Object.keys(from.params).length) );
    // console.log('beforeEach::from:: ', from);

    // se tiver sem os parametros no to
    if (Object.keys(to.params).length === 0 && Object.keys(from.params).length > 0) {
        to.params.stabs = from.params.stabs;
        to.params.categs = from.params.categs;
        to.params.idCat = from.params.idCat;
        to.params.subCatIndex = from.params.subCatIndex;
        to.params.anuncios = from.params.anuncios;
        console.log('beforeEach::to::IF ', to.params);
    }

    console.log('beforeEach::to::q::len   ', Object.keys(to.query).length );
    console.log('beforeEach::from::q::len ', Object.keys(from.query).length );
    // se tiver sem os parametros no to
    if (Object.keys(to.query).length === 0 && Object.keys(from.query).length > 0) {
        // to.query = from.query; // se deixar isso da erro. E ele nao volta. Comentado em 20/09/2022
        console.log('beforeEach::to.query::IF ', to.query);
    }

    if (to.name === 'sEstabSimple' && (from.name === 'Estabelecimento' || from.name === 'mEstabelecimento') &&
        to.params.estabSimple === from.params.estabSimple) {
        console.log('Voltando de um estabelecimento para a pag. intermediaria');
        console.log('this: ', this.a);
        to.params.back = true;
        // next('/go');
        this.a.back();
        return;
    }

    // Redirect if fullPath begins with a hash (ignore hashes later in path)
    if (to.fullPath.substr(0,2) === "/#") {
        const path = to.fullPath.substr(2);
        next(path);
        return;
    }
    next();
});



// WEBPACK FOOTER //
// ./src/router/index.js